<div class="ai-alert" *ngIf="showAlert" @fadeSlide>
  <span class="icon"><img src="assets/images/stars.svg"/></span>
  <span class="message">
    AI-generated insights are directional and should be interpreted using business judgment.
  </span>
  <button class="close-btn" (click)="closeAlert()">×</button>
</div>
